import React, { useEffect, useState } from 'react';
import './css/Customers.scss';
import { ROUTE_CUSTOMERS } from '../routes/Customer/Routes';
import { Outlet } from 'react-router-dom';
import { MultiSelectCheckBoxListInstructions } from '../CustomAccordionItemList/SelectListInstructions';
import { CustomAccordion } from '../components/CustomAccordion/CustomAccordion';

const CustomersContainer = () => {
  let pageTitle = ROUTE_CUSTOMERS.title;

  useEffect(() => {
    const title = ROUTE_CUSTOMERS.title;
    document.title = title;
  }, []);
  return (
    <>
      <h1>{pageTitle}</h1>

      <CustomAccordion
        itemList={<MultiSelectCheckBoxListInstructions/> }

      />

      <Outlet />
    </>

  );
}

export default CustomersContainer;
